// Runtime env-var validation. Fail loud at startup if something's missing.
// All vars must start with VITE_ to be exposed to the browser bundle by Vite.

function req(name: string): string {
  const v = import.meta.env[name]
  if (!v || typeof v !== 'string') {
    throw new Error(`[env] Missing required env var: ${name}. Check app-next/.env.local`)
  }
  return v
}

function opt(name: string): string | undefined {
  const v = import.meta.env[name]
  return typeof v === 'string' && v.length > 0 ? v : undefined
}

export const env = {
  firebase: {
    apiKey:            req('VITE_FIREBASE_API_KEY'),
    authDomain:        req('VITE_FIREBASE_AUTH_DOMAIN'),
    projectId:         req('VITE_FIREBASE_PROJECT_ID'),
    storageBucket:     req('VITE_FIREBASE_STORAGE_BUCKET'),
    messagingSenderId: req('VITE_FIREBASE_MESSAGING_SENDER_ID'),
    appId:             req('VITE_FIREBASE_APP_ID'),
  },
  recaptchaSiteKey: req('VITE_RECAPTCHA_SITE_KEY'),
  sentryDsn:        opt('VITE_SENTRY_DSN'),
  appVersion:       opt('VITE_APP_VERSION') ?? 'dev',
  isDev:            import.meta.env.DEV,
  isProd:           import.meta.env.PROD,
}
